module.exports = __webpack_public_path__ + "img/pic-3.a20eed9f.png";